import React from 'react';
import Modal from "react-modal";

const MediosDePago = ({ modalIsOpen, closeModal, Gestor, Modificar, Total }) => {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '260px',
            padding: '2px'
        }
    };
    return (
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} ariaHideApp={false} className={'mymodalMP'} style={customStyles}>
            <div className='tituloPantalla'>
                <p style={{ display: 'inline-block' }}> Medios de Pago {Total}</p>
                
            </div>

            <div style={{ marginLeft: '0px', marginTop: '5px', fontSize: '10px', padding: '5px' }}>


                {['Efectivo', 'Tarjeta', 'Cheque', 'Transferencia', 'Tercero', 'Sinpe', 'Plataforma'].map((medio, index) => (
                    <div className="row" key={index}>
                        <div className="col-50" style={{ padding: '0 10px' }}>
                            <label>{medio}:</label>
                        </div>
                        <div className="col-50" style={{ padding: '0 10px' }}>
                            <input
                                type="text"
                                id={medio}
                                autoComplete='off'
                                name={medio}
                                className="w-full border rounded p-1"
                                onChange={Modificar}
                                value={Gestor[medio]}
                            />
                        </div>
                    </div>
                ))}


                <div className="row">
                    <div className="col-25">
                        <button style={{ width: '90%' }} onClick={closeModal}>Guardar</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default MediosDePago;